import * as Draggable from '@givebutter/primitives/draggable';
import arrayMove from 'array-move';

const handleDragEnd = (event: Draggable.DragEndEvent, order: number[]) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
        const oldIndex = order.indexOf(active.id as number);
        const newIndex = order.indexOf(over?.id as number);

        return arrayMove(order, oldIndex, newIndex);
    }

    return order;
};

export { handleDragEnd };
